import * as React from 'react'
import { Link, LinkProps } from 'react-router-dom'

import Text, { TextProps } from 'components/common/Text'
import theme from 'theme'

export const EmptyState: React.FC = ({ children, ...rest }) => (
  <div
    css={{
      display: 'grid',
      gap: theme.space[2],
      placeItems: 'center',
      backgroundColor: theme.colors.panel[0],
      borderRadius: theme.borderRadius[0],
      padding: theme.space[5]
    }}
    {...rest}
  >
    {children}
  </div>
)

export const EmptyStateIcon: React.FC = props => (
  <span
    css={{
      display: 'grid', // collapse height to content
      color: theme.colors.steel[2],
      fontSize: theme.fontSizes[6]
    }}
    {...props}
  />
)

export const EmptyStateTitle: React.FC<TextProps> = props => {
  return <Text as="h3" {...props} />
}

export const EmptyStateText: React.FC<TextProps> = props => {
  return <Text as="p" css={{ fontSize: theme.fontSizes[2] }} {...props} />
}

export const EmptyStateLink: React.FC<TextProps & LinkProps> = props => {
  return (
    <Text
      as={Link}
      color="blue"
      css={{ fontSize: theme.fontSizes[2] }}
      {...props}
    />
  )
}
